export const selectStyles = {
    control: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            boxShadow: 'none',
            height:51
        }
    },
  };